const category = 'AppSpecificResearch';

const cards = [
    {
        name: "All Claims",
        id: "allClaims",
        fields: [
            [{
                id: "InitialInteractionExclusionsContent"
            }],
            [{
                type: "content",
                content: `<h6 class="qvo-color-grey-600">AUTO PAY AND AUTO PROVISIONAL CREDIT<h6>`
            }],
            [{
                id: "DisableDefaultProvisionalCreditReview",
            }],
            [
                {
                    id: "ShouldReviewProprietaryTransactions",
                },
            ],
            [
                {
                    id: "ShouldReviewATOClaims",
                },
            ],
            [
                {
                    id: "AutoPayConfig",
                    layout: [
                        [
                            {
                                id: "UseExpertAutoPayOption",
                            },
                        ],
                        [
                            {
                                id: "BasicAutoPayOption",
                                layout:
                                    [
                                        [{
                                            type: "contentGroup",
                                            items: [
                                                {
                                                    type: "content",
                                                    content: "Upon submission, automatically pay claims that are less than or equal to",
                                                },
                                                {
                                                    type: "config",
                                                    id: "IIDFinalAutoPayThreshold",
                                                },
                                                {
                                                    type: "content",
                                                    content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                                },
                                                {
                                                    type: "config",
                                                    id: "AttemptRecoveryAfterAutoPay",
                                                },
                                                {
                                                    type: "config",
                                                    id: "SkipMerchantCollaborationAfterAutoPay",
                                                },
                                            ],
                                        }]
                                    ]
                            },
                        ],
                        [
                            {
                                id: "ExpertAutoPayOption",
                                layout:
                                    []
                            },
                        ],
                    ],
                },
            ],
            [
                {
                    id: "PCConfig",
                    layout: [
                        [
                            {
                                id: "UseExpertPCOption",
                            },

                        ],
                        [
                            {
                                id: "BasicPCOption",
                                layout:
                                    [
                                        [{
                                            type: "contentGroup",
                                            items: [
                                                {
                                                    type: "content",
                                                    content: "Upon submission, automatically grant provisional credit to claims that are less than or equal to",
                                                },
                                                {
                                                    type: "config",
                                                    id: "IIDFinalPCThreshold",
                                                },
                                                {
                                                    type: "content",
                                                    content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                                },
                                                {
                                                    id: "WithholdPCForCBDocs",
                                                    type: "config"
                                                }
                                            ],
                                        }]
                                    ]
                            },
                        ],
                        [
                            {
                                id: "ExpertPCOption",
                                layout:
                                    []
                            },
                        ],
                        [
                            {
                                id: "IIDPCOptionForNonRegulatoryDisputes",
                            },
                        ],
                    ],
                },
            ],
            [{
                type: "content",
                content: `<h6 class="qvo-color-grey-600">EXCLUSIONS<h6>`
            }],
            [{
                id: "AllClaimsInitialInteractionExclusions"
            }],
            [{
                type: "content",
                content: `<h6 class="qvo-color-grey-600">PROVISIONAL CREDIT REVIEW<h6>`
            }],
            [{
                type: "contentGroup",
                items: [
                    {
                        type: "config",
                        id: "BOProvisionalCreditReviewContent"
                    }, {
                        type: "config",
                        id: "BOProvisionalCreditReview"
                    }

                ]
            }],
            [{
                type: "contentGroup",
                items: [
                    {
                        type: "config",
                        id: "BOPCReviewPostSLAActionGuidance"
                    }, {
                        type: "config",
                        id: "BOProvisionalCreditReviewPostSLAAction"
                    }
                ]
            }],
            [{
                type: "content",
                content: `<h6 class="qvo-color-grey-600">WRITE OFF THRESHOLD<h6>`
            }],
            [{
                id: "WriteOffThresholdContent"
            }],
            [{
                type: "contentGroup",
                items: [
                    {
                        type: "group",
                        items: [
                            { id: "WriteOffThresholdNoReviewAmountContent" },
                            { id: "WriteOffThresholdNoReviewAmount" },
                            { id: "WriteOffRemainingDisputesThresholdNoReviewAmountContent" },
                            { id: "WriteOffRemainingDisputesThresholdNoReviewAmount" },
                        ],
                    },
                    {
                        type: "group",
                        items: [
                            { id: "WriteOffThresholdNoReviewAmountAppliesContent" },
                            { id: "WriteOffThresholdNoReviewAmountApplies" },
                        ],
                    },
                ]
            }],
            [{
                type: "content",
                content: `<h6 class="qvo-color-grey-600">WRITE OFF REVIEW<h6>`
            }],
            [{
                id: "WriteOffThresholdNoReviewContent"
            }],
            [{
                type: "contentGroup",
                items: [
                    {
                        type: "group",
                        items: [
                            { id: "BOWriteOffWhenPCGrantedAndNoNewInfo", configHideLabel: false, },
                        ],
                    },
                    {
                        type: "group",
                        items: [
                            { id: "BOWriteOffWhenPCGrantedAndNoNewInfoAppliesContent" },
                            { id: "BOWriteOffWhenPCGrantedAndNoNewInfoApplies" },
                        ],
                    },
                ]
            }],
            [{
                type: "content",
                content: `<h6 class="qvo-color-grey-600">MANUAL TRANSACTION ENTRY<h6>`
            }],
            [{
                id: "IsManualTransactionAllowed"
            }],
            [{ id: "AllowIntakeUsersToAddManualTransactions" }],
            [{
                type: "content",
                content: `<h6 class="qvo-color-grey-600">Post Collaboration Decision Automation<h6>`,
                helpContent: "After claim submission, when a claim did not qualify for Auto Pay or Auto PC, claims will be routed to Merchant Collaboration and then a merchant credit check will be performed. If no credit was identified during these steps, the thresholds in this section can be utilized to write-off or grant PC after merchant collaboration and a merchant credit check is performed."
            }],
            [{
                id: "BOEvaluateFinalCreditPostMerchCollab"
            }],
            [{
                id: "UseBOPostCollabFinalCreditDecision",
            }],
            [
                {
                    id: "BasicPostCollabAutoFinalCreditOption",
                    layout:
                        [
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, a final credit will be issued on claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "PostCollabAutoFinalCreditThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "PostCollabAutoFinalCreditDisputesThreshold",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [{
                id: "BOEvaluatePCPostMerchCollab"
            }],
            [{
                id: "UseBOPostCollabProvisionalCreditDecision",
            }],
            [
                {
                    id: "BasicPostCollabAutoGrantPCOption",
                    layout:
                        [
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "PostCollabAutoGrantPCThreshold",
                                    },
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
    {
        name: "ACH",
        id: "ach",
        tooltip: "The settings added in this section apply to ACH claims only.",
        fields: [
            [
                {
                    id: "ACHIIDHeader",
                }
            ],
            [
                {
                    id: "ACHExpertAutoPayOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">AutoPay Thresholds</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayACHThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayACHTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayACH",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPayForACHNonFraud",
                                    },
                                ],
                            }],
                        ]
                },
            ],
            [
                {
                    id: "ACHExpertPCOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Thresholds</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalPCThresholdACH",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPCForACHNonFraud",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "ACHIIDExclusionsHeader",
                }
            ],
            [
                {
                    id: "ACHInitialInteractionExclusions",
                }
            ],
            [
                {
                    id: "ACHAdditionalSettingsHeader",
                }
            ],
            [
                {
                    id: "ACHAdditionalSettings",
                }
            ],
            [
                {
                    id: "ACHDocRequirementsHeader",
                }
            ],
            [
                {
                    id: "BOEnableACHDocRequirement",
                }
            ],
            [
                {
                    id: "ACHExpertWriteOffDecisionOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Write-Off Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, a final credit will be issued on fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudThresholdACH",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudClaimDisputesThresholdACH",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically write-off non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudThresholdACH",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudClaimDisputesThresholdACH",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "PostCollabConfigGroupACH",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCFraudThresholdACH",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCNonFraudThresholdACH",
                                    },
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
    {
        name: "Card",
        id: "card",
        tooltip: "The settings added in this section apply to Card claims only.",
        fields: [
            [
                {
                    id: "CardIIDHeader",
                }
            ],
            [
                {
                    id: "CardExpertAutoPayOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">AutoPay Thresholds</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayCardFraudThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayCardFraudTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayCardFraud",
                                    },
                                    {
                                        type: "config",
                                        id: "SkipMerchantCollaborationAfterAutoPayCardFraud",
                                    },
                                ],
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayCardNonFraudThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayCardNonFraudTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayCardNonFraud",
                                    },
                                    {
                                        type: "config",
                                        id: "SkipMerchantCollaborationAfterAutoPayCardNonFraud",
                                    },
                                ],
                            }],
                        ]
                },
            ],
            [
                {
                    id: "CardExpertPCOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Thresholds</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalPCThresholdCardFraud",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "WithholdPCForCBDocsCardFraud",
                                    },
                                ],
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalPCThresholdCardNonFraud",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "WithholdPCForCBDocsCardNonFraud",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "CardIIDExclusionsHeader",
                }
            ],
            [
                {
                    id: "CardInitialInteractionExclusions",
                }
            ],
            [
                {
                    id: "IsSameDayATMManualTransactionAllowedContent"
                }
            ],
            [
                {
                    id: "IsSameDayATMManualTransactionAllowed"
                }
            ],
            [
                {
                    id: "CardExpertWriteOffDecisionOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Write-Off Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, a final credit will be issued on fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudThresholdCard",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudClaimDisputesThresholdCard",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically write-off non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudThresholdCard",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudClaimDisputesThresholdCard",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "PostCollabConfigGroupCard",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCFraudThresholdCard",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCNonFraudThresholdCard",
                                    },
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
    {
        name: "Check",
        id: "check",
        tooltip: "The settings added in this section apply to Check claims only.",
        fields: [
            [
                {
                    id: "CheckIIDHeader",
                }
            ],
            [
                {
                    id: "CheckExpertAutoPayOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Pay Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayCheckThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayCheckTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayCheck",
                                    },
                                    {
                                        type: "config",
                                        id: "SkipMerchantCollaborationAfterAutoPayCheck",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPayForCheckNonFraud",
                                    },
                                ],
                            }],
                        ]
                },
            ],
            [
                {
                    id: "CheckExpertPCOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Provisional Credit Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalPCThresholdCheck",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPCForCheckNonFraud",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "CheckExpertWriteOffDecisionOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Write-Off Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, a final credit will be issued on fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudThresholdCheck",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudClaimDisputesThresholdCheck",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically write-off non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudThresholdCheck",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudClaimDisputesThresholdCheck",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "PostCollabConfigGroupCheck",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCFraudThresholdCheck",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCNonFraudThresholdCheck",
                                    },
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
    {
        name: "RTP",
        id: "rtp",
        tooltip: "The settings added in this section apply to RTP claims only.",
        fields: [
            [
                {
                    id: "RTPIIDHeader",
                }
            ],
            [
                {
                    id: "RTPExpertAutoPayOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Pay Thresholds</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayRTPThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayRTPTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayRTP",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPayForRTPNonFraud",
                                    },
                                ],
                            }],
                        ]
                },
            ],
            [
                {
                    id: "RTPExpertPCOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Provisional Credit Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalPCThresholdRTP",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPCForRTPNonFraud",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "RTPIIDExclusionsHeader",
                }
            ],
            [
                {
                    id: "RTPInitialInteractionExclusions",
                }
            ],
            [
                {
                    id: "RTPExpertWriteOffDecisionOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Write-Off Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, a final credit will be issued on fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudThresholdRTP",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudClaimDisputesThresholdRTP",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically write-off non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudThresholdRTP",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudClaimDisputesThresholdRTP",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "PostCollabConfigGroupRTP",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCFraudThresholdRTP",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCNonFraudThresholdRTP",
                                    },
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
    {
        name: "Zelle",
        id: "zelle",
        tooltip: "The settings added in this section apply to Zelle claims only.",
        fields: [
            [
                {
                    id: "ZelleIIDHeader",
                }
            ],
            [
                {
                    id: "ZelleExpertAutoPayOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">AutoPay Thresholds</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayZelleThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayZelleTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayZelle",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPayForZelleNonFraud",
                                    },
                                ],
                            }],
                        ]
                },
            ],
            [
                {
                    id: "ZelleExpertPCOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Thresholds</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalPCThresholdZelle",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPCForZelleNonFraud",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "ZelleIIDExclusionsHeader",
                }
            ],
            [
                {
                    id: "ZelleInitialInteractionExclusions",
                }
            ],
            [
                {
                    id: "ZelleExpertWriteOffDecisionOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Write-Off Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, a final credit will be issued on fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudThresholdZelle",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudClaimDisputesThresholdZelle",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically write-off non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudThresholdZelle",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudClaimDisputesThresholdZelle",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "PostCollabConfigGroupZelle",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCFraudThresholdZelle",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCNonFraudThresholdZelle",
                                    },
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
    {
        name: "Wire",
        id: "wire",
        tooltip: "The settings added in this section apply to Wire claims only.",
        fields: [
            [
                {
                    id: "WireIIDHeader",
                }
            ],
            [
                {
                    id: "WireExpertAutoPayOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Pay Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayWireThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayWireTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayWire",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPayForWireNonFraud",
                                    },
                                ],
                            }],
                        ]
                },
            ],
            [
                {
                    id: "WireExpertPCOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Provisional Credit Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalPCThresholdWire",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPCForWireNonFraud",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "WireExpertWriteOffDecisionOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Write-Off Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, a final credit will be issued on fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudThresholdWire",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditFraudClaimDisputesThresholdWire",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically write-off non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudThresholdWire",
                                    },
                                    {
                                        type: "content",
                                        content: "and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantFinalCreditNonFraudClaimDisputesThresholdWire",
                                    },
                                ],
                            }]
                        ]
                },
            ],
            [
                {
                    id: "PostCollabConfigGroupWire",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Provisional Credit Decision</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCFraudThresholdWire",
                                    },
                                    {
                                        type: "content",
                                        content: "Post merchant collaboration and merchant credit check, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "AutoGrantPCNonFraudThresholdWire",
                                    },
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
    {
        name: "Convenience Check",
        id: "cnvCheck",
        tooltip: "The settings added in this section apply to Convenience Check claims only.",
        fields: [
            [
                {
                    id: "CnvCheckIIDHeader",
                }
            ],
            [
                {
                    id: "CnvCheckExpertAutoPayOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Pay Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayCnvCheckThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayCnvCheckTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayCnvCheck",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPayForCnvCheckNonFraud",
                                    },
                                ],
                            }],
                        ]
                },
            ],
            [
                {
                    id: "CnvCheckExpertPCOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Provisional Credit Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDPCThresholdCnvCheckFraud",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    }
                                ],
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDPCThresholdCnvCheckNonFraud",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    }
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
    {
        name: "Balance Transfer",
        id: "balanceTransfer",
        tooltip: "The settings added in this section apply to Balance Transfer claims only.",
        fields: [
            [
                {
                    id: "BalTransIIDHeader",
                }
            ],
            [
                {
                    id: "BalTransExpertAutoPayOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Pay Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically pay claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayBalTransThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span> and all transactions are below",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDFinalAutoPayBalTransTxnThreshold",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    },
                                    {
                                        type: "config",
                                        id: "AttemptRecoveryAfterAutoPayBalTrans",
                                    },
                                    {
                                        type: "config",
                                        id: "DisableAutoPayForBalTransNonFraud",
                                    },
                                ],
                            }],
                        ]
                },
            ],
            [
                {
                    id: "BalTransExpertPCOption",
                    layout:
                        [
                            [{
                                type: "content",
                                content: `<p class="subtitle-2">Auto Provisional Credit Threshold</p>`,
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDPCThresholdBalTransFraud",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    }
                                ],
                            }],
                            [{
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Upon submission, automatically grant provisional credit to non-fraud claims that are less than or equal to",
                                    },
                                    {
                                        type: "config",
                                        id: "IIDPCThresholdBalTransNonFraud",
                                    },
                                    {
                                        type: "content",
                                        content: "<span class='qvo-color-grey-600'>(blank is disabled)</span>",
                                    }
                                ],
                            }]
                        ]
                },
            ],
        ],
    },
];

export { cards, category };